import axios from "axios";
import authHeader from "./auth/auth-header";

const baseUrl = process.env.REACT_APP_API_URL;

/**
 * Recuperar grupo por id
 * @param { string } idGroup - identificador del grupo
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 

const getGroupById = async(idGroup) => {

  const token = await authHeader();
  const url = `${ baseUrl }/group/findById/${idGroup}`;
  
  return axios.get(url,
  {headers: token}
  ).then(
      (response) => {
    return response.data;
  })
};

/**
 * Recuperar lista de grupos
 * @param { string } an8 - identificador del cliente
 * @returns {any} recupera la respuesta de la solicitud
 * @author alSanchez - ETE
 * @version 1.0.0 - Noviembre 2023
 */ 
const getAllGroupsByCustomer = async(noCustomer) => {
  const token = await authHeader();
  const url = `${ baseUrl }/group/findAll/${noCustomer}`;
  return axios
    .get(url, {
      headers: token
    }
      ).then(response => {
      console.log(response.data)
      return response.data;
     }
     )
};

const createGroup = async(roleData) => {
  const token = await authHeader();
  const url = `${ baseUrl }/group/create`;
return axios.post(url, roleData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};

const updateGroup = async(roleData, idRol) => {
  const token = await authHeader();
  const url = `${ baseUrl }/group/update/${idRol}`;
return axios.put(url, roleData,
  {
    headers: token
  }
  ).then(
  (response) => {
  return response.data;
})
};


export default {
    getGroupById,
    getAllGroupsByCustomer,
    createGroup,
    updateGroup
};